/**
 * Single source of truth for the project footer / attribution line.
 * Used by the app footer and the generated HTML quality report.
 */
export const FOOTER_TEXT =
  "Built with love, given away free. Better tools for everyone. — Brandon Cook · San Luis Valley Industries, LLC · info@sanluisvalley.industries";
